import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=9d619808&scoped=true&"
import script from "./MediaImage.vue?vue&type=script&lang=ts&"
export * from "./MediaImage.vue?vue&type=script&lang=ts&"
import style0 from "./MediaImage.vue?vue&type=style&index=0&id=9d619808&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d619808",
  null
  
)

export default component.exports